module.exports = __webpack_public_path__ + "fonts/group_42969_1.svg";